import { ContentfulClientApi } from 'contentful';

if (
  !process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID ||
  !process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN
) {
  throw new Error(
    "All CONTENTFUL_* .env must be set to configure Contenful's SDK",
  );
}

const contentful = require('contentful');

const contentfulSDKConfig = ({
  space,
  accessToken,
  environment,
}: {
  space: string;
  accessToken: string;
  environment?: string;
}) => {
  const config: {
    space: string;
    accessToken: string;
    environment?: string;
  } = {
    space,
    accessToken,
  };

  if (environment) {
    config.environment = environment;
  }

  return config;
};

// Create a client to use for our REST API queries
export const contentfulRESTClient: ContentfulClientApi = contentful.createClient(
  contentfulSDKConfig({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
    accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
    environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT,
  }),
);
